import gql from 'graphql-tag';

const GET_INVOICE_SCHEDULE = gql`
  query getInvoiceSchedule($input: InvoiceScheduleIdentifierInput!) {
    getInvoiceSchedule(input: $input) {
      scheduleId
      name
      description
      scheduleDefinition
      conditions {
        conditionId
        applicableItemType
        includeOverageItem
        applicableItemSubType
        conditionIncludedItems {
          itemId
          name
        }
      }
      nextScheduleDate
      lastScheduleDate
      invoicePaymentTerm {
        paymentTermId
        paymentTermName
        paymentTermValue
        placeholder
        systemPaymentTerm
      }
      generateEmptyInvoice
      autoSend
      updatedBy {
        userId
        name
        firstName
        lastName
        email
      }
      createdTime
      updatedTime
      status
      overriddenSettings
    }
  }
`;

const GET_INVOICE_SCHEDULE_LIST = gql`
  query getInvoiceScheduleList($input: ClientIdentifierInput) {
    getInvoiceScheduleList(input: $input) {
      scheduleId
      name
      description
      scheduleDefinition
      nextScheduleDate
      lastScheduleDate
      generateEmptyInvoice
      conditions {
        conditionId
        applicableItemType
        includeOverageItem
        applicableItemSubType
        conditionIncludedItems {
          itemId
        }
      }
      autoSend
      updatedBy {
        userId
        name
        firstName
        lastName
        email
      }
      createdTime
      updatedTime
      status
      overriddenSettings
    }
  }
`;

export { GET_INVOICE_SCHEDULE, GET_INVOICE_SCHEDULE_LIST };
